import type { LanguageOption } from "./types";

export const LANGUAGES: LanguageOption[] = [
  { code: "he", label: "עברית", flag: "🇮🇱" },
  { code: "en", label: "English", flag: "🇺🇸" },
];
